<template lang="html">
  <apexcharts
    type="line"
    width="100%"
    :height="height"
    :options="chartOptions"
    :series="series"
  />
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import helpers from '@/mixins/helpers'
export default {
  components: {
    apexcharts: VueApexCharts
  },
  mixins: [ helpers ],
  props: {
    labels: Array,
    labelFormat: {
      type: Function,
      default: v => v
    },
    series: Array,
    options: Object,
    height: {
      type: Number,
      default: 400
    }
  },
  data () {
    return {
      chart: null
    }
  },
  computed: {
    yMax () {
      let max = 0
      this.series.forEach(s => {
        max = Math.max(max, Math.max(...s.data))
      })
      return max + (max * 0.02)
    },
    chartDefault () {
      return {
        chart: {
        },
        stroke: {
          width: [0, 3]
        },
        plotOptions: {
            bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0],
          formatter: (val) => {
            return this.labelFormat(val)
          },
          offsetY: -10,
          style: {
            fontSize: '11px',
            fontWeight: 400,
            colors: ["#304758","#304758"]
          },
          background: {
            enabled: false
          }
        },
        series: this.series,
        yaxis: {
          // max: this.yMax,
          labels: {
            show: false,
            formatter: (val) => {
              return this.labelFormat(val)
            }
          }
        },
        xaxis: {
          categories: this.labels,
          axisTicks: {
            show: false
          },
          tooltip: {
            enabled: true,
          }
        }
      }
    },
    chartOptions () {
      return { ...this.chartDefault, ...this.options }
    }
  },
  watch: {
    // series: {
    //   handler (v) {
    //     this.chart.updateSeries(v)
    //   },
    //   deep: true
    // }
  },
  mounted () {
    // this.chart = new ApexCharts(this.$refs.chart, this.chartOptions)
    //
    // this.chart.render()
  }
}
</script>

<style lang="css" scoped>

</style>
